import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Primary } from '../../../assets/Colors';
import Coaching from '../../../assets/adminIcons/leadership.png';
import SideBar from '../../../components/SideBar';
import { Components } from '../../../assets/Dimensions';
import { setSelectedItem } from '../../../redux/actions/sidebarAction';

const CoachAdminDashboard = ({ setSelectedItem }) => {
    const history = useHistory();

    useEffect(() => {
        setSelectedItem('');
    }, []);

    const menuItems = [
        { title: 'Coaches', path: '/CoachesAdminPanel', icon: Coaching },
    ];

    return (
        <div>
            <SideBar />
            <div style={{ 
                padding: 20, 
                marginLeft: Components.SideBarWidth + 15, 
                marginRight: 30,
                paddingTop: 20
            }}>
            <Typography variant="h4" style={{ color: Primary.TextColor, marginBottom: 20 }}>
                Coach Admin Dashboard
            </Typography>
            <Grid container spacing={3}>
                {menuItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card 
                            style={{ cursor: 'pointer', height: '100%' }}
                            onClick={() => history.push(item.path)}
                        >
                            <CardContent style={{ textAlign: 'center' }}>
                                <img src={item.icon} alt={item.title} style={{ width: 50, height: 50, marginBottom: 10 }} />
                                <Typography variant="h6" component="h2">
                                    {item.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch) => ({
    setSelectedItem: (item) => dispatch(setSelectedItem(item))
});

export default connect(null, mapDispatchToProps)(CoachAdminDashboard);
